import React, { Component } from 'react';
import queryString from 'querystring';
import { RenderPage } from './Helpers';
import Assets from './Assets';
import { Publish, Subscribe } from './PubSub';
import { savestate, getstate } from './StateMtg';
import '@inas/nao-styles';

// eslint-disable-next-line react/no-unsafe
export class DynApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Visited: {},
      DynComps: {},
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.location.hash !== this.props.location.hash) {
      return false;
    } else {
      return true;
    }
  }

  getUrl() {
    const { location } = this.props;
    let url = `/assets/index.json`;
    console.log('debug url dashboard', url);
    // url = url.endsWith('/') ? `${url}index.json` : `${url}`;
    // url = url.replace('.html', '.json');
    let QString = null;
    if (location.search.startsWith('?')) {
      const search = location.search.substring(1);
      QString = queryString.parse(search);
    }

    return { Url: url, QString };
  }

  get404Url = () => {
    // TODO support multiple site by removing Global folder hardcoding
    // const url404 = `/Assets/${window.location.hostname}/page404.json`;
    const url404 = `/Assets/Global/mod-ui/page404.json`;
    return url404;
  };

  loadPage(pageUrl) {
    const page = Assets[pageUrl];
    if (page) {
      page.url = pageUrl;
      this.setState(prevState => ({
        DynComps: { ...prevState.DynComps, [pageUrl]: page },
      }));

      const { module_type: moduleType, module_details: { layout: moduleLayout, assets: { regions } = {} } = {} } = page;

      if (moduleType === 'Page') {
        if (moduleLayout && regions && Object.keys(regions).length > 0) {
          Object.keys(regions).forEach(key => {
            // Loop Through Regions
            const region = regions[key]; // Key is the Region Name, and region is the JSon Node
            if (Array.isArray(region) && region.length > 0) {
              for (let index = 0; index < region.length; index += 1) {
                const element = region[index];
                if (element.path && element.module_type && element.module_type === 'Component_Ref') {
                  const res = Assets[element.path];
                  page.module_details.assets.regions[key][index] = res.data;
                  this.setState(prevState => ({
                    DynComps: { ...prevState.DynComps, [pageUrl]: page },
                  }));
                }
              }
            }
          });
        }
      }
    } else {
      this.setState(prevState => ({
        DynComps: { ...prevState.DynComps, [pageUrl]: '404' },
      }));
    }
  }

  render() {
    const url404 = this.get404Url();
    const fullUrl = this.getUrl();
    let outPage = <div />;
    const date = new Date();
    const { location } = this.props;
    const Api = {
      savestate,
      getstate,
      location,
      Publish,
      Subscribe,
    };

    // Record Visted time (This also prevents a React Error)
    const { Visited } = this.state;
    if (!Visited[fullUrl.Url]) {
      this.setState(prevState => ({
        Visited: { ...prevState.Visited, [fullUrl.Url]: { Visited: date.getTime() } },
      }));
      this.loadPage(fullUrl.Url);
    }
    // Render Dynamic Component
    const { DynComps } = this.state;
    if (DynComps[fullUrl.Url] && DynComps[fullUrl.Url] !== '404') {
      outPage = RenderPage(DynComps[fullUrl.Url], Api, fullUrl);
    }
    // Rendert 404
    if (DynComps[fullUrl.Url] === '404' && DynComps[url404]) {
      outPage = RenderPage(DynComps[url404], Api, { Url: url404, QString: null });
    }

    return <div>{outPage}</div>;
  }
}

export default DynApp;
